import React, { useMemo } from 'react';

import { BuilderBlocks, Builder } from '@builder.io/react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import FableticsModal from '~/shared/components/FableticsModal';

const contentWrapperStyles = css`
  background: none;
`;

const TriggerWrapper = styled.span`
  pointer-events: auto;
`;

const BuilderModal = ({
  attributes: { style: _, ...dialogProps },
  content,
  builderBlock,
  isOpen,
  modalTrigger,
  showCloseButton,
  title = 'Modal',
  transitionProps = {
    enter: {
      opacity: 1,
      transform: 'scale(1, 1)',
    },
    from: {
      opacity: 0,
      transform: 'scale(0.5, 0.5)',
    },
    leave: {
      opacity: 0,
      transform: 'scale(0.5, 0.5)',
    },
  },
}) => {
  const trigger = useMemo(
    () => (
      <TriggerWrapper>
        <BuilderBlocks
          blocks={modalTrigger}
          dataPath="component.options.modalTrigger"
          parentElementId={builderBlock.id}
        />
      </TriggerWrapper>
    ),
    [modalTrigger, builderBlock.id]
  );

  return (
    <FableticsModal
      contentWrapperStyles={contentWrapperStyles}
      dialogProps={dialogProps}
      isOpen={Builder.isEditing ? isOpen : undefined}
      showCloseButton={showCloseButton}
      title={title}
      transitionEnter={transitionProps?.enter}
      transitionFrom={transitionProps?.from}
      transitionLeave={transitionProps?.leave}
      trigger={trigger}
      data-builder-component-type="modal"
    >
      <BuilderBlocks
        blocks={content}
        dataPath="component.options.content"
        parentElementId={builderBlock.id}
      />
    </FableticsModal>
  );
};

BuilderModal.propTypes = {
  attributes: PropTypes.object,
  builderBlock: PropTypes.object,
  content: PropTypes.array,
  isOpen: PropTypes.bool,
  modalTrigger: PropTypes.array,
  showCloseButton: PropTypes.bool,
  title: PropTypes.string,
  transitionProps: PropTypes.string,
};

export default BuilderModal;
